// Password reset functions
// Handles forgot password functionality

import { sendPasswordResetEmail } from 'firebase/auth';
import { getAuth } from '../firebase/config';

interface PasswordResetParams {
  email: string;
}

interface PasswordResetResult {
  success: boolean;
  error?: string;
}

/**
 * Sends a password reset email to the user
 */
export async function sendPasswordReset({ email }: PasswordResetParams): Promise<PasswordResetResult> {
  try {
    const auth = getAuth();
    await sendPasswordResetEmail(auth, email);
    
    // Log password reset request (we don't have userId yet, so we'll log with email)
    // Note: This is a best-effort log since we don't have the user ID at this point
    console.log('Password reset email sent to:', email);
    
    return {
      success: true,
    };
  } catch (error) {
    console.error('Password reset error:', error);
    const errorMessage = (error as Error).message;
    
    // Don't reveal if email exists or not for security
    // Always return success message to user
    if (errorMessage.includes('user-not-found')) {
      return {
        success: true, // Return success even if user doesn't exist (security best practice)
      };
    }
    
    return {
      success: false,
      error: errorMessage,
    };
  }
}

